import React from "react";
import { observer } from "mobx-react";
import Paper from "@mui/material/Paper";
import SendIcon from "@mui/icons-material/Send";
import RootStore from "../stores/RootStore";
import { IconButton } from "@mui/material";

/**
 * Container für ein einzelnes Widget
 * mit ID, Button etc
 * Positionierung des Buttons hängt von der Konfigurierung ab
 * Widget, status etc. werden aus dem UIStore entnommen
 */
const SingleWidgetContainer = observer(
  ({
    id,
    index,
    width,
    isActive,
    Icon = SendIcon,
    children,
    direction = "right",
    uiStore,
    mobile,
  }) => {
    const store =
      uiStore !== undefined
        ? uiStore
        : RootStore.uiStore.subUiStores[direction];
    const {
      closeWidget,
      openWidget,
      closeable = true,
      hasSiblings = true,
      buttonPosition,
      rotateButton = false,
    } = store;
    const buttonStyle = {
      position: mobile && isActive ? undefined : "absolute",
      top: mobile && isActive ? undefined : 5 + 50 * index,
      background: !isActive ? "white" : "#ccc",
      transition: "background 1s",
      transform: rotateButton && isActive ? "scaleX(-1)" : "scaleX(1)",
      zIndex: mobile && isActive ? 1 : undefined,
    };
    const buttonMargin = "-7px";

    if (
      direction === "right" ||
      (direction === "onMap" && buttonPosition.includes("left"))
    ) {
      buttonStyle.left = 0;
      buttonStyle.transform =
        mobile && direction !== "onMap" && isActive
          ? "translate(0,0)"
          : "translate(-100%,0)";
      buttonStyle.marginLeft =
        mobile && direction !== "onMap" && isActive ? 0 : buttonMargin;
    }
    if (
      direction === "left" ||
      (direction === "onMap" && buttonPosition.includes("right"))
    ) {
      buttonStyle.right = 0;
      buttonStyle.transform =
        mobile && direction !== "onMap" && isActive
          ? "translate(0,0)"
          : "translate(+100%,0)";
      buttonStyle.marginRight =
        mobile && direction !== "onMap" && isActive ? 0 : buttonMargin;
    }
    if (
      direction === "bottom" ||
      (direction === "onMap" && buttonPosition.includes("top"))
    ) {
      buttonStyle.top = undefined;
      buttonStyle.left = 5 + 50 * index;
      buttonStyle.transform = "translate(0,-100%)";
      buttonStyle.marginBottom = buttonMargin;
    }
    if (
      direction === "top" ||
      (direction === "onMap" && buttonPosition.includes("bottom"))
    ) {
      buttonStyle.top = undefined;
      buttonStyle.bottom = 5 + 50 * index;
      // buttonStyle.left = 5 + 50 * index;
      buttonStyle.transform = "translate(0,+100%)";
      buttonStyle.marginTop = buttonMargin;
    }

    const button =
      !closeable && !hasSiblings ? (
        <></>
      ) : (
        <IconButton
          style={buttonStyle}
          // className={}
          disabled={!closeable}
          onClick={(p) => {
            if (isActive) {
              closeWidget();
            } else {
              openWidget(id);
            }
          }}
        >
          <Icon open={isActive}></Icon>
        </IconButton>
      );

    return (
      <>
        {(!mobile || !isActive) && button}
        <Paper
          style={{
            display: isActive ? "flex" : "none",
            // paddingLeft: "5px",
            // paddingRight: "5px",
            zIndex: mobile && isActive ? 1 : undefined,
            // paddingTop: mobile && isActive ? 50 : 0,
            background: mobile && isActive && "#FFF",
            overflow: mobile && isActive ? "hidden" : undefined,
            height: "100%",
            position: "relative",
          }}
        >
          <div
            style={{
              flexGrow: 1,
              overflow: "auto",
              width: "100%",
              maxWidth: "100%",
              height: "100%",
              // paddingTop: mobile && isActive ? 50 : undefined,
              display: "flex",
              flexDirection: "column",
              alignItems:
                mobile && isActive
                  ? (direction === "left" && "end") ||
                    (direction === "right" && "start")
                  : undefined,
            }}
          >
            <div
              style={{
                flexGrow: 1,
                width: "100%",
                // paddingBottom: 15,
                paddingTop: 0,
              }}
            >
              {children}
            </div>
          </div>
        </Paper>
      </>
    );
  }
);
export default SingleWidgetContainer;
